export default {"src":"/_next/static/media/mail.df5cad88.svg","height":24,"width":24};